import { Box, Table, Text } from '@factorialco/deprecated-design-system'
import { AtsCandidateEmailActionFragment } from 'generated/resources/graphql'
import { capitalize } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { delayLabel, sendFromLabel } from 'modules/ats/lib/utils/candidateEmailActions'

import { ApplicationPhaseTag } from '../../ApplicationPhaseTag'

type ActionDetailType = 'phase' | 'sender' | 'delay'

interface ActionDetail {
  title: string
  label?: string
  type: ActionDetailType
}

interface Props {
  hiddenDetails?: ActionDetailType[]
  smartAction: AtsCandidateEmailActionFragment
}

export const SmartActionsItemDetail = ({ smartAction, hiddenDetails }: Props) => {
  const actionDetails: ActionDetail[] = [
    { title: i18n.t('ats.smart_actions.setup_cards.phase'), type: 'phase' },
    {
      title: i18n.t('ats.smart_actions.setup_cards.sender'),
      label: sendFromLabel(smartAction.emailFrom),
      type: 'sender',
    },
  ]

  if (smartAction.delay !== 'now')
    actionDetails.splice(actionDetails.length, 0, {
      title: i18n.t('ats.smart_actions.setup_cards.delay'),
      label: delayLabel(smartAction.delay),
      type: 'delay',
    })

  return (
    <Table hideBorder autoLayout density="compact">
      {actionDetails
        .filter((detail) => !hiddenDetails?.includes(detail.type))
        .map((details) => (
          <Table.Row key={`${smartAction.id}-${details.title}`}>
            <Table.Cell
              noBorder
              paddingY="s4"
              paddingX="s0"
              width={70}
              verticalAlign={details.type === 'phase' ? 'top' : 'middle'}
            >
              <Text.Normal>{details.title}</Text.Normal>
            </Table.Cell>
            <Table.Cell noBorder paddingY="s8">
              {details.type === 'phase' ? (
                <Box flexDirection="row" flexWrap="wrap" gap="s8">
                  {smartAction?.atsApplicationPhases.map((phase) => (
                    <ApplicationPhaseTag key={phase.id} applicationPhase={phase} />
                  ))}
                </Box>
              ) : (
                <Text.Normal weight="medium" color="grey1000">
                  {capitalize(details.label)}
                </Text.Normal>
              )}
            </Table.Cell>
          </Table.Row>
        ))}
    </Table>
  )
}
